import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

const ContactSection = () => {
  const form = useRef();
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_zzesvdt', 'template_mowug9e', form.current, '8CQYH892NjTn9bKfo')
      .then((result) => {
          console.log(result.text);
          setSuccessMessage('¡Mensaje enviado con éxito!');
          setErrorMessage('');
          form.current.reset();
      }, (error) => {
          console.log(error.text);
          setErrorMessage('Error al enviar el mensaje. Intenta nuevamente.');
          setSuccessMessage('');
      });
  };

  return (
    <section className="py-20 px-4 bg-[#03ADED] text-white" id="contacto">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row gap-12">

          {/* Texto lado izquierdo */}
          <div className="md:w-1/2">
            <h2 className="text-3xl font-bold mb-6">Hablemos de tu proyecto</h2>
            <p className="text-xl mb-8 text-[#B3E5FC]">
              ¿Tienes dudas? Escríbenos y te responderemos en menos de 24 horas.
            </p>
            <div className="space-y-6">
              <div className="flex items-start">
                <div className="text-2xl mr-4">📧</div>
                <div>
                  <h4 className="font-semibold">Correo Electrónico</h4>
                  <p className="text-[#B3E5FC]">contacto@yupisoft.lat</p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="text-2xl mr-4">📱</div>
                <div>
                  <h4 className="font-semibold">WhatsApp</h4>
                  <p className="text-[#B3E5FC]">+51 972 843 376</p>
                  <a
                    href="https://wa.me/51972843376?text=Hola%20YupiSoft,%20quiero%20más%20información."
                    className="inline-block mt-2 bg-white text-[#03ADED] font-bold py-2 px-6 rounded-lg hover:bg-gray-100 transition-colors"
                  >
                    Chatear ahora
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Formulario lado derecho */}
          <div className="md:w-1/2">
            <form ref={form} onSubmit={sendEmail} className="bg-white p-8 rounded-xl shadow-lg">
              <div className="mb-6">
                <label className="block text-gray-700 mb-2" htmlFor="name">Nombre</label>
                <input 
                  type="text" 
                  id="name" 
                  name="name" 
                  required
                  className="w-full px-4 py-3 text-gray-700 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#03ADED] focus:border-transparent"
                  placeholder="Tu nombre"
                />
              </div>
              <div className="mb-6">
                <label className="block text-gray-700 mb-2" htmlFor="email">Correo</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  required
                  className="w-full px-4 text-gray-700 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#03ADED] focus:border-transparent"
                  placeholder="tu@correo.com"
                />
              </div>
              <div className="mb-6">
                <label className="block text-gray-700 mb-2" htmlFor="message">Mensaje</label>
                <textarea 
                  id="message" 
                  name="message" 
                  rows="4" 
                  required
                  className="w-full px-4 text-gray-700 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#03ADED] focus:border-transparent"
                  placeholder="Cuéntanos sobre tu negocio"
                ></textarea>
              </div>

              {/* Mensajes de éxito o error */}
              {successMessage && <p className="text-green-500 font-semibold mb-4">{successMessage}</p>}
              {errorMessage && <p className="text-red-500 font-semibold mb-4">{errorMessage}</p>}

              <button 
                type="submit" 
                className="w-full bg-[#03ADED] hover:bg-[#0288D1] text-white font-bold py-3 px-6 rounded-lg transition-colors"
              >
                Enviar mensaje
              </button>
            </form>
          </div>

        </div>
      </div>
    </section>
  );
};

export default ContactSection;
